import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IdentityService } from '../../../services/identity/identity.service';
import { Observable } from 'rxjs';

export function MpApiInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

  const identityService = inject(IdentityService);

  const token = identityService.getAccessToken();

  if (isMagicPalletRequest(request.url) && token) {
    return next(request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    }));
  }
  return next(request);
}

function isMagicPalletRequest(url: string): boolean {
  return environment.api_base_urls?.ms_defaults?.some(baseUrl => url.includes(baseUrl));
}

